<template>
    <div>
        <el-button type="primary" @click="onAddBooks">添加</el-button>
        <AllList
                :allList="allList"
                @on-edit="onEdit"
                @on-update="onUpdate"
                class="all-list"
        ></AllList>
        <BookAdd v-model="isShowDrawer" @on-update="onUpdate" :bookId="bookId" :type="modalType" :sequence="sequence"></BookAdd>
    </div>
</template>
<script>
    // 引入组件
    import AllList from "../books/list";
    import BookAdd from "../books/books-add-edit";
    // api
    import {GetBookList} from "../../api/book";
    // js
    import moment from "moment";

    export default {
        name: "leaderList",
        components: {
            AllList,
            BookAdd
        },
        data() {
            return {
                sequence:0,
                total:0,
                modalType: 0,
                isShowDrawer: false,
                bookId: null,
                params: {
                    pageNum: 0,
                    pageSize: 999
                },
                allList: []
            };
        },
        methods: {
            // 添加
            onAddBooks() {
                this.modalType = 0;
                this.isShowDrawer = true;
                this.sequence = this.total +1;
            },
            // 修改
            onEdit(cell) {
                this.modalType = 1;
                this.isShowDrawer = true;
                this.bookId = cell.bookId;
            },
            onUpdate() {
                this.GetBookList();
            },
            // 获取列表
            GetBookList() {
                GetBookList(this.params).then(res => {
                    if (res.status) {
                        this.allList = res.data.dataList.map(item => {
                            item.title = item.bookName;
                            item.createTime = moment(item.updateTime).format("YYYY-MM-DD");
                            if (item.bookPicPOList.length > 0) {
                                item.imageUrl = item.bookPicPOList[0].imageUrl;
                            }
                            return item;
                        });
                        this.total = res.data.total;
                    }
                });
            }
        },
        mounted() {
            this.GetBookList();
        }
    };
</script>
<style lang="less" scoped>
    .all-list {
        margin-top: 20px;
    }
</style>
